// extracted by mini-css-extract-plugin
export default {"root":"Header_root__UJgD3","back":"Header_back__op0QM"};